module.exports = __webpack_public_path__ + "static/img/ic_treatmentClass2.de72e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_treatmentClass2.png
// module id = BiRP
// module chunks = 1